<p-dialog
  [visible]="state.open"
  (visibleChange)="!$event && close()"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="!activating"
  [dismissableMask]="!activating"
  [style]="{ width: 'min(1100px, 96vw)' }"
  [contentStyle]="{ 'max-height': '82vh' }"
  [header]="t.UPGRADE_TITLE"
>
  <!-- Rendered only while open: the plan cards load their data (plans, referral offer,
       Pioneer status, current plan) on init, so they must be created on each open - not
       once at app start, when the user may not even be signed in yet. -->
  @if (state.open) {
    @if (activating) {
      <div class="upgrade-activating" role="status">
        <i class="bi bi-arrow-repeat spin" aria-hidden="true"></i>
        <span>{{ t.UPGRADE_ACTIVATING }}</span>
      </div>
    } @else if (chosenPlan) {
      <div class="upgrade-checkout">
        <button type="button" class="upgrade-back" (click)="backToPlans()">
          <i class="bi bi-arrow-left" aria-hidden="true"></i> {{ t.UPGRADE_BACK }}
        </button>
        <h3 class="upgrade-plan-name">{{ chosenPlan.name }}</h3>
        <app-plan-checkout
          [planId]="chosenPlan.id"
          returnPath="/home/plans?checkout=success"
          (completed)="onPaid()"
          (alreadySubscribed)="onPaid()"
        ></app-plan-checkout>
      </div>
    } @else {
      <p class="upgrade-subtitle">{{ subtitle }}</p>
      <app-plans
        [embedded]="true"
        (planChosen)="choose($event)"
        (keepFree)="keepFree()"
        (pioneerClaimed)="onPioneerClaimed()"
      ></app-plans>
    }
  }
</p-dialog>
